import { render, staticRenderFns } from "./audio.vue?vue&type=template&id=98bbc5c6&scoped=true&"
import script from "./audio.vue?vue&type=script&lang=js&"
export * from "./audio.vue?vue&type=script&lang=js&"
import style0 from "./audio.vue?vue&type=style&index=0&id=98bbc5c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98bbc5c6",
  null
  
)

export default component.exports